import React from 'react';
import ReactDOM from 'react-dom';
import './style/styles.scss'
import App from './App';


export const renderApp = (state, callback = () => {
}) => {
  ReactDOM.render(
    <App/>, document.getElementById('root'));
};

let state = {
  location: window.location.pathname,
};


renderApp(state);
